import React from 'react'

import StyledSlatOuter from './StyledSlatOuter'
import StyledSlatInner from './StyledSlatInner'

export const GoalSection = () => {
  return (
    <GoalSectionStyles id='objetivo'>
      <StyledSlatInner className='goal__inner'>
        <h2 className='goal__title'>Nuestro Objetivo</h2>
        <div className='goal__text'>
          &quot;Asegurarnos que a través de nuestro modelo de servicios, los clientes mantengan siempre la continuidad de sus operaciones.&quot;
        </div>
      </StyledSlatInner>
    </GoalSectionStyles>
  )
}

const GoalSectionStyles = StyledSlatOuter.extend`
  .goal {
    &__inner {
    }

    &__title {
      font-size: 25px;
      text-align: left;
      text-transform: uppercase;
      @media (min-width: ${({theme}) => theme.large.start}) {
        font-size: 35px;
      }
    }

    &__text {
      font-style: italic;
      font-size: 25px;
      text-align: left;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/GoalSection.js